import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('apps');

const state = {
  appSearchResults: [],
  currentApp: {},
};

const getters = {
  appSearchResults: (state) => state.appSearchResults,
  currentApp: (state) => state.currentApp,
};

const mutations = {
  setAppSearchResults: (state, appSearchResults) => {
    state.appSearchResults = appSearchResults;
  },
  updateAppSearchResults: (state, task) => {
    const index = state.appSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.appSearchResults, index, task);
  },
  removeFromAppSearchResults: (state, id)=>{
    state.appSearchResults.data = state.appSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.appSearchResults.total--;
  },
  setCurrentApp: (state, currentApp) => {
    state.currentApp = currentApp;
  },
};

const actions = {
  async searchApps({commit}, data) {
    const response = await API.search(data.query);
    if (data.opts?.setResultsInStore) {
      commit('setAppSearchResults', response.data);
    }
    return response.data;
  },
  async loadApp({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentApp', response.data);
    return response.data;
  },
  async createApp({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateApp({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateAppSearchResults', response.data);
    return response.data;
  },
  async deleteApp({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromAppSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
